import axios from "./axiosConfig";

export function saveMobileErrors(data) {
    return axios.post('/api/v1/record-errors', data)
        .then((response) => {
            // handle success
            return response.data;
        })
        .catch((error) => {
            return error;
        });
}
